import { render } from "./affiliate-footer-bar.vue?vue&type=template&id=1fd1c204&scoped=true&ts=true"
import script from "./affiliate-footer-bar.vue?vue&type=script&lang=ts"
export * from "./affiliate-footer-bar.vue?vue&type=script&lang=ts"

import "./affiliate-footer-bar.vue?vue&type=style&index=0&id=1fd1c204&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd1c204"]])

export default __exports__